module.exports = __webpack_public_path__ + "25be5d5b16a42571bde5295351ca1370.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-25.png
// module id = 2188
// module chunks = 0